import {Component, Input, OnInit} from '@angular/core';
import {SelectItem} from 'primeng/api';
import {DadService} from '../../../services/dad.service';
import {formatDate} from '@angular/common';
import {saveAs} from 'file-saver';
import {UtilsService} from '../../../../appSharedModule/services/utils.service';

@Component({
  selector: 'app-dad-status',
  templateUrl: './dad-status.component.html',
  styleUrls: ['./dad-status.component.scss']
})
export class DadStatusComponent implements OnInit {

  @Input() set exchangeNamesList(value) {
    this.exchangeItems = value;
    this.selectedExchanges = value.map(exchange => exchange.value);
  }

  @Input() set companiesItems(value) {
    this.selectedClients = [];
    this.uniqCompanyItems = [];
    value.forEach(companyItem => {
      if (this.uniqCompanyItems.filter(item => item.value === companyItem.value).length === 0) {
        this.uniqCompanyItems.push(companyItem);
        this.selectedClients.push(companyItem.value);
      }
    });
  }

  selectedClients: SelectItem[] = [];
  dateFilterFrom: any;
  dateFilterTo: any;
  selectedExchanges = [];
  uniqCompanyItems = [];
  exchangeItems = [];

  constructor(private dadService: DadService, private utilsService: UtilsService) {
  }

  ngOnInit() {
    this.initializeDateFilter();
  }

  private initializeDateFilter() {
    this.dateFilterFrom = new Date();
    this.dateFilterFrom.setDate(1);
    this.dateFilterFrom.setMonth(this.dateFilterFrom.getMonth() - 2);
    this.dateFilterTo = new Date();
    this.dateFilterTo.setDate(1);
  }

  exportCSV() {
    this.dadService.getDadListForStatus(
      this.selectedExchanges,
      this.dateFilterFrom,
      this.dateFilterTo,
      this.selectedClients
    ).subscribe({
      next: res => {
        const fileNamePrefix = formatDate(new Date(), 'yyyy-MM-dd', 'en-US');
        let fileNameSuffix = '';
        if (this.selectedExchanges.length === 1) {
          fileNameSuffix += '_DAD_Status_' + this.selectedExchanges[0] + '.csv';
        } else {
          fileNameSuffix += '_DAD_Status.csv';
        }
        this.downLoadFile(res, fileNamePrefix + fileNameSuffix);
      },
      error: () => {
        this.utilsService.displayMessage('The DAD rebilling file could not be exported', 'Please try again later.', 'error');
      }
    });
  }

  downLoadFile(data: any, fileName: string) {
    const blob = new Blob([data]);
    saveAs(blob, fileName);
  }
}
